import { render, staticRenderFns } from "./FaqsPage.vue?vue&type=template&id=1efd9333&scoped=true&"
import script from "./FaqsPage.vue?vue&type=script&lang=js&"
export * from "./FaqsPage.vue?vue&type=script&lang=js&"
import style0 from "./FaqsPage.vue?vue&type=style&index=0&id=1efd9333&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd9333",
  null
  
)

export default component.exports